import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SeoPaginationComponent } from '@web/shared/ui';
import { CourseSearchLoadMoreBtnComponent } from '../course-search-load-more-btn/course-search-load-more-btn.component';

@Component({
	selector: 'uc-course-search-pagination',
	templateUrl: './course-search-pagination.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [CommonModule, SeoPaginationComponent, CourseSearchLoadMoreBtnComponent],
})
export class CourseSearchPaginationComponent {
	hasMorePages = input.required<boolean>();
	isLoading = input.required<boolean>();
	page = input.required<number>();
	searchTerm = input<string>();

	loadMore = output<number>();
}
